import { useEffect } from 'react'

import type { SignupData } from '../SignupForm'

// Placeholder for Lucide CheckCircle or use inline SVG
const CheckCircleIcon = () => (
  <svg className='text-[#FFA236] mx-auto h-16 w-16' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
    />
  </svg>
)

interface SignupCompleteScreenProps {
  onStart: () => void
  signupData: SignupData
}

export function SignupCompleteScreen({ onStart, signupData }: SignupCompleteScreenProps) {
  useEffect(() => {
    // 2초 후 자동으로 홈 화면으로 이동
    const timer = setTimeout(() => {
      onStart()
    }, 2000)

    // 컴포넌트 언마운트 시 타이머 정리
    return () => clearTimeout(timer)
  }, [onStart])

  // 클릭 시 즉시 홈 화면으로 이동
  const handleClick = () => {
    onStart()
  }

  return (
    <div
      className='fixed inset-0 bg-white z-[60] flex flex-col items-center justify-center p-6 font-sans cursor-pointer'
      onClick={handleClick}
    >
      <div className='text-center space-y-6'>
        <CheckCircleIcon />
        <h2 className='text-2xl font-bold text-gray-800'>
          좋아 앞으로 잘 부탁해
          <br /> {signupData.nickname}!
        </h2>
      </div>
    </div>
  )
}
